import { Dispatch } from "redux";

export let dispatchGlobal: Dispatch<any>;

export const setGlobalDispatch = (dispatch: Dispatch<any>) => {
  dispatchGlobal = dispatch;
};
